import { render, staticRenderFns } from "./StartupProfilePage.vue?vue&type=template&id=4c372a51&"
import script from "./StartupProfilePage.vue?vue&type=script&lang=js&"
export * from "./StartupProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports